<script>
import {notificationMethods, dashboardMethod} from "@/state/helpers";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import DashboardTable from "@/components/dashboard/DashboardTable";

import Stat from "@/components/dashboard/stat";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stat,
    DashboardTable,
  },
  data() {
    return {
      totalPages: 0,
      title: "Ana Sayfa",
      items: [
        {
          text: "Ana Sayfa",
          href: "/",
          active:true
        },
      ],
      statData: {
        person: {
          icon: "bx bxs-user-detail",
          title: "Plasiyerler",
          value: "",
        },
        customer: {
          icon: "bx bx-user",
          title: "Müşteriler",
          value:"",
        },
        product: {
          icon: "bx bx-cube",
          title: "Ürünler",
          value: "",
        },
      },
      productColumns: [
        {
          key: "name",
          name: "Ürün Adı"
        },
        {
          key: "code",
          name: "Ürün Kodu"
        },
        {
          key: "balance",
          name: "Bakiye"
        },
        {
          key: "updatedAt",
          name: "Son Güncelleme"
        },
      ],
      installmentPaymentColumns: [
        {
          key: "customerName",
          name: "Müşteri"
        },
        {
          key: "contractDate",
          name: "Evrak Tarihi"
        },
        {
          key: "installmentDate",
          name: "Taksit Tarihi"
        },
        {
          key: "amount",
          name: "Ödenecek Tutar"
        },
      ],
      pieChart: {
        series: [],
        chartOptions: {
          labels: [],
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
          },
          responsive: [{
            breakpoint: 600,
            options: {
              chart: {
                height: 240
              },
              legend: {
                show: false
              },
            }
          }]
        }
      },
      isLoading: false,
      data: {},
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
    };
  },
  mounted() {
    this.getDashboard()
  },

  methods: {
    ...dashboardMethod,
    ...notificationMethods,
     redirectToDelayedInstallments() {
      this.$router.push({ name: 'delayedInstallmentReports' });
    },
    redirectToApproachingInstallments() {
      this.$router.push({ name: 'approachingInstallmentReports' });
    },
    getDashboard(){
      this.fetchDashboard().then(res=>{
        // getting category ready for fields
        this.data = JSON.parse(JSON.stringify(res));
        this.data.delayedPayments = this.data.delayedPayments.filter(elem=> {
            if(elem.contractId) {
              return elem
            }
        })
        this.statData.person.value = this.data.personCount.toString()
        this.statData.customer.value = this.data.customerCount.toString()
        this.statData.product.value = this.data.productCount.toString()
        this.data.personSales.map(sales=>{
          this.pieChart.series.push(parseInt(sales.amount))
          this.pieChart.chartOptions.labels.push(sales._id.person[0].name)
        })
      })
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Plasiyer Satış</h4>
            <!-- Pie Chart -->
            <apexchart
                class="apex-charts"
                type="pie"
                dir="ltr"
                :series="pieChart.series"
                :options="pieChart.chartOptions"
            ></apexchart>
          </div>
        </div>

      </div>
      <!-- end col -->
      <div class="col-xl-8 stock">
        <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>

        <div class="card ">
          <div class="card-body">
            <h4 class="card-title mb-4">Stok Bakiyeleri</h4>
            <!-- Transactions table -->
            <DashboardTable
                :columns="productColumns"
                :datas="data.stockBalance"
                :updating="fetchingStats"
            />
            <div class="d-flex justify-content-end">
              <button @click="$router.push({name:'products'})" class="btn link-info">Tümünü Görüntüle</button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- end row -->


    <div class="row">
      <div class="col-lg-12 delay">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Ödemesi Gecikenler</h4>
            <!-- Transactions table -->
            <!-- Transactions table -->
            <DashboardTable
                :columns="installmentPaymentColumns"
                :datas="data.delayedPayments.slice(0, 10)"
            :updating="fetchingStats"
            />
            <div class="d-flex justify-content-end">
            <button @click="redirectToDelayedInstallments" class="btn link-info">Tümünü Görüntüle</button>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Ödemesi Yaklaşanlar</h4>
            <!-- Transactions table -->
            <DashboardTable
                :columns="installmentPaymentColumns"
                :datas="data.approachingPayments"
                :updating="fetchingStats"
            />
          </div>

        </div>
      </div>
      <!-- end col -->
    </div>

    <!-- end row -->

  </Layout>
</template>
<style>
.stock .total-pages-content, .delay .total-pages-content{
  display: none!important;
}

</style>


